import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';

const FbtTitle = () => {
  const t = useTranslations();
  return (
    <CatHeading className="text-capitalize" variant="title-sm">
      {t('FREQUENTLY_BOUGHT_TOGETHER')}
    </CatHeading>
  );
};

export default FbtTitle;
